import type { ReactElement } from "react";

import { cx, styled } from "simplydo/react/styled";

import { PopupContentEl } from "./Popup.styles";
import type { PopupContentProps } from "./Popup.types";

/**
 *  */

const PopupContentComponent = (props: PopupContentProps): ReactElement => {
  const { children, content, className, style } = props;
  return (
    <PopupContentEl className={cx(className)} style={style}>
      {children ?? content}
    </PopupContentEl>
  );
};

export const PopupContent = styled(PopupContentComponent)``;
